<!-- 首页、用户登录 -->
<!-- 灰色背景 -->
<div class="ild_bg" style="display: none;"></div>
<!-- 登录弹框 -->
<div class="ild_login_con" style="display: none;">
  <img class="logo" src="./assets/ILD_home_logo2.png" alt="">     
  <div>
    <img src="./assets/login_ic_js.png" alt="">
    <input type="text" placeholder="工作人员姓名">
  </div>
  <div>
    <img src="./assets/login_ic_mm.png" alt="">
    <input type="text" placeholder="密码">
  </div>
  <p>
    <a href="">注册</a>
    <a href="">忘记密码</a>
  </p>
  <button>登录</button>
</div>
<!-- 首页 -->
<div class="ild_con none">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p class="active">
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="banner">
    <img src="./assets/ILD_home_banner.png" alt="">
  </div>
  <div class="news_notice">
    <div class="news">
      <div class="news_title"><em>新闻资讯</em><a>更多 ></a></div>
      <dl>
        <dt><img src="./assets/img.png" alt=""></dt>
        <dd>
          <p>[专题讲座]XXXXXXXXXXxxxxXXXX</p>
          <span>我们邀请到临床、影像、病理、细胞室、肺功能室等老师从不同角度讲解LD、讲座时间初步拟订每周五下午5点至6点，中日医院的医生可到14层东区查房室现场听课讲座同时......</span>
          <em>2023-06-21</em>
        </dd>
      </dl>
      <dl>
        <dt><img src="./assets/img.png" alt=""></dt>
        <dd>
          <p>[专题讲座]XXXXXXXXXXxxxxXXXX</p>
          <span>我们邀请到临床、影像、病理、细胞室、肺功能室等老师从不同角度讲解LD、讲座时间初步拟订每周五下午5点至6点，中日医院的医生可到14层东区查房室现场听课讲座同时......</span>
          <em>2023-06-21</em>
        </dd>
      </dl>
      <dl>
        <dt><img src="./assets/img.png" alt=""></dt>
        <dd>
          <p>[专题讲座]XXXXXXXXXXxxxxXXXX</p>
          <span>我们邀请到临床、影像、病理、细胞室、肺功能室等老师从不同角度讲解LD、讲座时间初步拟订每周五下午5点至6点，中日医院的医生可到14层东区查房室现场听课讲座同时......</span>
          <em>2023-06-21</em>
        </dd>
      </dl>
      <dl>
        <dt><img src="./assets/img.png" alt=""></dt>
        <dd>
          <p>[专题讲座]XXXXXXXXXXxxxxXXXX</p>
          <span>我们邀请到临床、影像、病理、细胞室、肺功能室等老师从不同角度讲解LD、讲座时间初步拟订每周五下午5点至6点，中日医院的医生可到14层东区查房室现场听课讲座同时......</span>
          <em>2023-06-21</em>
        </dd>
      </dl>
    </div>
    <div class="notice">
      <div class="notice_title news_title pb0"><em>通知公告</em><a>更多 ></a></div>
      <div class="notice_con">
        <img src="./assets/ILD_home_tzgg.png" alt="">
        敬请期待
      </div>
      <div class="notice_list">
        <ul>
          <li>
            <img src="./assets/ra_home_ic_zd.png" alt="">
            <a>通知1：XXXXXXXXXXX，XXXXXXX...</a>
          </li>
          <li>
            <img src="./assets/ra_home_ic_zd.png" alt="">
            <a>通知2：XXXXXXXXXXX，XXXXXXX...</a>
          </li>
          <li>
            <img src="./assets/ra_home_ic_zd.png" alt="">
            <a>通知3：XXXXXXXXXXX，XXXXXXX...</a>
          </li>
          <li>
            <img src="./assets/ra_home_ic_zd.png" alt="">
            <a>通知4：XXXXXXXXXXX，XXXXXXX...</a>
          </li>
          <li>
            <img src="./assets/ra_home_ic_zd.png" alt="">
            <a>通知5：XXXXXXXXXXX，XXXXXXX...</a>
          </li>
        </ul>
      </div>
      <div class="notice project">
        <div class="notice_title">项目动态</div>
        <!-- 滚动图片 -->
        <div id="box"> 
          <div id="boxin"> 
            <div id="neirong"> 
              <p>
                <img src="./assets/ILD_zlzxjslc_jslcjs_2.png" alt=""> 
              </p>
              <p>
                <img src="./assets/ILD_zlzxjslc_jslcjs_3.png" alt=""> 
              </p>
              <p>
                <img src="./assets/ILD_zlzxjslc_jslcjs_4.png" alt=""> 
              </p>
              <p>
                <img src="./assets/ILD_zlzxjslc_jslcjs_5.png" alt=""> 
              </p>
            </div> 
              <div id="neirong2"></div> 
          </div> 
        </div>
        <!-- 滚动图片 end -->
      </div>
    </div>
  </div>
  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持 北京风云朗健科技有限公司</p>
      <p>电话010-67309068 E-mail service@healthbit.cn</p>
    </div>
  </div>
  <div class="totop">
    <a href=""><img src="./assets/ILD_home_ic_zd.png" alt=""></a>
  </div>
</div>
<!-- 首页、用户登录 end -->

<!-- 资讯列表 -->
<div class="ild_con none">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p class="active">
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="notice_list_con">
    <div>
      <div class="crumbs">
        <a href="">首页</a>
        <span>></span>
        <p>[新闻资讯]</p>
      </div>
    </div>
  </div>
  <div class="news_notice news_list">
    <div class="news">
      <dl>
        <dt><img src="./assets/img.png" alt=""></dt>
        <dd>
          <p>[专题讲座]XXXXXXXXXXxxxxXXXX</p>
          <span>我们邀请到临床、影像、病理、细胞室、肺功能室等老师从不同角度讲解LD、讲座时间初步拟订每周五下午5点至6点，中日医院的医生可到14层东区查房室现场听课讲座同时......</span>
          <em>2023-06-21</em>
        </dd>
      </dl>
      <dl>
        <dt><img src="./assets/img.png" alt=""></dt>
        <dd>
          <p>[专题讲座]XXXXXXXXXXxxxxXXXX</p>
          <span>我们邀请到临床、影像、病理、细胞室、肺功能室等老师从不同角度讲解LD、讲座时间初步拟订每周五下午5点至6点，中日医院的医生可到14层东区查房室现场听课讲座同时......</span>
          <em>2023-06-21</em>
        </dd>
      </dl>
      <dl>
        <dt><img src="./assets/img.png" alt=""></dt>
        <dd>
          <p>[专题讲座]XXXXXXXXXXxxxxXXXX</p>
          <span>我们邀请到临床、影像、病理、细胞室、肺功能室等老师从不同角度讲解LD、讲座时间初步拟订每周五下午5点至6点，中日医院的医生可到14层东区查房室现场听课讲座同时......</span>
          <em>2023-06-21</em>
        </dd>
      </dl>
      <dl>
        <dt><img src="./assets/img.png" alt=""></dt>
        <dd>
          <p>[专题讲座]XXXXXXXXXXxxxxXXXX</p>
          <span>我们邀请到临床、影像、病理、细胞室、肺功能室等老师从不同角度讲解LD、讲座时间初步拟订每周五下午5点至6点，中日医院的医生可到14层东区查房室现场听课讲座同时......</span>
          <em>2023-06-21</em>
        </dd>
      </dl>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <span>1</span>
      <span class="active">2</span>
      <span>3</span>
      <span>4</span>
      <span>5</span>
      <span>6</span>
      <span>7</span>
      <span>8</span>
      <span>9</span>
      <span>10</span>
      <em>上一页</em>
      <em>下一页</em>
    </div>
    <!-- 分页 end -->
  </div>
  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持 北京风云朗健科技有限公司</p>
      <p>电话010-67309068 E-mail service@healthbit.cn</p>
    </div>
  </div>
  <div class="totop">
    <a href=""><img src="./assets/ILD_home_ic_zd.png" alt=""></a>
  </div>
</div>

<!-- 资讯列表 end -->

<!-- 后台数据 -->
<div class="ild_con" style="display: none;">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="banner">
    <img src="./assets/ILD_htsj_banner.png" alt="">
  </div>
  <div class="data_con">
    <div>
      <img src="./assets/qushi.png" alt="">
    </div>
    <div>
      <img src="./assets/qushi.png" alt="">
    </div>
  </div>
  <div class="relation">
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 后台数据 end -->

<!-- 用户注册 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="">用户登录</a>
      <span>|</span>
      <a href="" class="active">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="register_con">
    <div class="register_box">
      <div class="register">用户注册</div>
      <div>
        <p>姓名</p>
        <input type="text" placeholder="请填写">
      </div>
      <div>
        <p>地区</p>
        <select name="" id="">
          <option value="0">请填写</option>
          <option value="1">1</option>
        </select>
      </div>
      <div>
        <p>手机号</p>
        <input type="text" placeholder="请填写">
        <button>获取验证码</button>
      </div>
      <div>
        <p>医院</p>
        <select name="" id="">
          <option value="0">请填写</option>
          <option value="1">1</option>
        </select>
      </div>
      <div>
        <p>
          医师证编号<br>
          或身份证号
        </p>
        <input type="text" placeholder="请填写">
      </div>
      <div>
        <p>医院</p>
        <input list="cookies" placeholder="请选择医院"/>
        <datalist id="cookies">
            <option value="北京协和医院"></option>
            <option value="通州路程医院"></option>
            <option value="北京大学人民医院"></option>
            <option value="北京大学第三医院"></option>
        </datalist>
      </div>
      <div class="save">
        <button>保存</button>
      </div>
    </div>
  </div>
  <div class="relation">
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 用户注册 end -->

<!-- 忘记密码 -->
<div class="ild_con" style="display: none;">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="">用户登录</a>
      <span>|</span>
      <a href="" class="active">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="register_con">
    <div class="register_box">
      <div class="password">找回密码</div>
      <div>
        <p>手机号</p>
        <input type="text" placeholder="请填写">
      </div>
      <div>
        <p>验证码</p>
        <input type="text" placeholder="请填写">
        <button>获取验证码</button>
      </div>
      <div>
        <p>新密码</p>
        <input type="password" placeholder="请填写">
      </div>
      <div class="save">
        <button>找回密码</button>
      </div>
    </div>
  </div>
  <div class="relation">
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 忘记密码 end -->

<!-- 项目介绍 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p class="active">
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="upding">
    <div class="p_nav">
      <a href="" class="active">项目介绍</a>
      <a href="">建设标准介绍</a>
      <a href="">文件下载</a>
    </div>
    <div class="p_con">
      <img src="./assets/ILD_xmjj_xmjs_1.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_2.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_3.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_4.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_5.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_6.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_7.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_8.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_9.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_10.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_11.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_12.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_13.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_14.png" alt="">   
      <img src="./assets/ILD_xmjj_xmjs_15.png" alt="">    
    </div>
  </div>
  
  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 项目介绍 end -->

<!-- 建设标准介绍 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p class="active">
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="upding">
    <div class="p_nav">
      <a href="">项目介绍</a>
      <a href="" class="active">建设标准介绍</a>
      <a href="">文件下载</a>
    </div>
    <div class="p_con">
      <img src="./assets/ILD_xmjj_jsbzjs_1.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_2.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_3.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_4.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_5.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_6.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_7.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_8.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_9.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_10.png" alt="">   
      <img src="./assets/ILD_xmjj_jsbzjs_11.png" alt="">     
    </div>
  </div>
  
  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 建设标准介绍 end -->

<!-- 文件下载 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p class="active">
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="upding">
    <div class="p_nav">
      <a href="">项目介绍</a>
      <a href="">建设标准介绍</a>
      <a href="" class="active">文件下载</a>
    </div>
    <div>
      <img src="./assets/ILD_xmjj_wjxz.png" alt="">   
    </div>
    <div class="up_btn">
      <p>
        <span>下载项目介绍PDF</span>        
        <img src="./assets/ILD_xmjj_wjxz_btn.png" alt="">   
      </p>
      <p>
        <span>下载建设标准PDF</span>  
        <img src="./assets/ILD_xmjj_wjxz_btn.png" alt="">  
      </p> 
    </div>
  </div>
  
  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 文件下载 end -->

<!-- 建设流程介绍 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p class="active">
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="upding">
    <div class="p_nav">
      <a href="" class="active">建设流程介绍</a>
      <a href="">报名相关附件下载</a>
    </div>
    <div class="p_con">
      <img src="./assets/ILD_zlzxjslc_jslcjs_1.png" alt="">   
      <img src="./assets/ILD_zlzxjslc_jslcjs_2.png" alt="">   
      <img src="./assets/ILD_zlzxjslc_jslcjs_3.png" alt="">   
      <img src="./assets/ILD_zlzxjslc_jslcjs_4.png" alt="">   
      <img src="./assets/ILD_zlzxjslc_jslcjs_5.png" alt="">   
      <img src="./assets/ILD_zlzxjslc_jslcjs_6.png" alt="">     
    </div>
  </div>
  
  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 建设流程介绍 end -->

<!-- 报名相关附件下载 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p class="active">
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="upding">
    <div class="p_nav">
      <a href="">建设流程介绍</a>
      <a href="" class="active">报名相关附件下载</a>
    </div>
    <div>
      <img src="./assets/ILD_zlzxjslc_bmxgfjxz.png" alt="">   
    </div>
    <div class="up_btn">
      <p>
        <span>承诺函下载</span>        
        <img src="./assets/ILD_zlzxjslc_bmxgfjxz_btn1.png" alt="">   
      </p>
      <p>
        <span>报名表下载</span>  
        <img src="./assets/ILD_zlzxjslc_bmxgfjxz_btn1.png" alt="">  
      </p> 
    </div>
    <div class="up_btn up_btn2">
      <p>
        <span>CTD-ILD诊疗实践中心建设标准 (2023年试行版)一评分细则及提交材料要求 下载</span> 
        <img src="./assets/ILD_zlzxjslc_bmxgfjxz_btn2.png" alt="">  
      </p>
    </div>
  </div>
  
  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 报名相关附件下载 end -->

<!-- 诊疗中心评审 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p class="active">
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>
  <div class="banner">
    <img src="./assets/ILD_zlzxps_banner.png" alt="">
  </div>
  <div class="up_btn">
    <p>
      <span>中心自评表下载</span>        
      <img src="./assets/ILD_zlzxps_btn.png" alt="">   
    </p>
  </div>
  <div class="zlzxps">
    <p>
      <img src="./assets/ILD_zlzxps_ic_sc.png" alt="">   
      <span>中心自评表上传(支持Word、Excel格式文档)</span>
    </p>
    <div>
      <p>
        <span>http://c:</span>
        <!-- 显示路径 -->
        <input class="input_path" type="text" value="F:\ILD\ILDWeb\src\assets">
        <!-- 文件上传 -->
        <input class="input_file" type="file">
      </p>
      <button>上传</button>
    </div>
    <p>
      <img src="./assets/ILD_zlzxps_ic_sc.png" alt="">   
      <span>中心自评附件材料上传(支持压缩包、Word、Excel、PDF格式文档)</span>
    </p>
    <div>
      <p>
        <span>http://d:</span>
        <!-- 显示路径 -->
        <input class="input_path" type="text" value="F:\ILD\ILDWeb\src\assets">
        <!-- 文件上传 -->
        <input class="input_file" type="file">
      </p>
      <button>上传</button>
    </div>
  </div>

  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 诊疗中心评审 end -->

<!-- 联系我们 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p class="active">
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>

  <div class="contact_us">
    <div>
      <p>项目办公室介绍</p>
      <span>Introduction</span>
    </div>
    <div>
      <img src="./assets/ILD_lxwm.png" alt="">
    </div>
  </div>

  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 联系我们 end -->

<!-- 通知公告 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>

  <div class="notice_list_con">
    <div>
      <div class="crumbs">
        <a href="">首页</a>
        <span>></span>
        <p>[通知公告]</p>
      </div>
      <div class="notice_list">
        <p>
          <img src="../assets/ra_home_ic_zd.png" alt="">
          <span>
            通知1：XXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXX，XXXXXXXXXXX，XXXXXXXXXXXX，XXXXXXXXXX，XXXXXXXXXXX
            <em>2023-07-04</em>
          </span>
        </p>
        <p>
          <img src="../assets/ra_home_ic_zd.png" alt="">
          <span>
            通知2：XXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXX，XXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXX
            <em>2023-07-04</em>
          </span>
        </p>
        <p>
          <img src="../assets/ra_home_ic_zd.png" alt="">
          <span>
            通知3：XXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXX，XXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXX
            <em>2023-07-04</em>
          </span>
        </p>
        <p>
          <img src="../assets/ra_home_ic_zd.png" alt="">
          <span>
            通知4：XXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXX，XXXXXXXXXXX，XXXXXXXXXXXXXXXXXXXXXX，XXXXXXXXXXX
            <em>2023-07-04</em>
          </span>
        </p>
      </div>
    </div>
  </div>

  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 通知公告 end -->

<!-- 通知公告详情 -->
<div class="ild_con">
  <div class="header_con">
    <div class="logo">
      <img src="./assets/ILD_home_logo.png" alt="">      
    </div>
    <div class="nav_top">
      <a href="" class="active">用户登录</a>
      <span>|</span>
      <a href="">用户注册</a>
      <span>|</span>
      <a href="">工作人员登录</a>
      <a href="" class="download">Future guideline相关材料下载</a>
    </div>
  </div>
  <div class="nav">
    <div class="nav_list">
      <p>
        <a href="">
          <i>首页</i>
          <em>Home</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>项目简介</i>
          <em>Project introduction</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心建设流程</i>
          <em>Construction process of dia-<br>gnosis and treatment center</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>诊疗中心评审</i>
          <em>Treatment center review</em>
        </a>
      </p>
      <p>
        <a href="">
          <i>联系我们</i>
          <em>Contact us</em>
        </a>
      </p>
    </div>
  </div>

  <div class="notice_list_con">
    <div>
      <div class="crumbs">
        <a href="">首页</a>
        <span>></span>
        <p>[专题讲座]XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXX,XXXX</p>
      </div>
      <div class="notice_detail">
        <div class="title">[专题讲座]XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXX,XXXX</div>
        <div class="time">2023-06-21</div>
        <img src="./assets/ILD_home_xwzx_tu.png" alt="">
        <div class="detail_test">XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX,XXXXXXXXXXXXXXXXXXXX</div>
      </div>
    </div>
  </div>

  <div class="relation">
    <div class="relation_con">
      <div class="title">联系方式:</div>
      <div class="relation_row">
        <p>联络人：任雁宏 (微信号 SUNSHINE7561)</p>
        <p>王诗尧 (微信号 DRWANG_0704)</p>
        <p>舒 适 (微信号 KARRYSS33)</p>
      </div>
      <div class="relation_row">
        <p>朱海念  13980797105 (技术)</p>
        <p>王南南  18911379505</p>
      </div>
      <div class="relation_row">
        <p>邮箱地址：ILDHXYLT@126.com  &nbsp;&nbsp;&nbsp;ILD_CHINA@163.COM</p>
      </div>
      <div class="relation_row">
        <p>报名网站：HTTP//ILD.HXYLT.ORG.CN/F</p>
      </div>
    </div>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>
</div>
<!-- 通知公告详情 end -->

<!-- 后台admin -->
<div class="admin_con" style="display: none;">
  <div class="left">
    <div class="admin_logo">
      <img src="./assets/ILD_admin_logo.png" alt="">
    </div>
    <div class="admin_nav">
      <a href="">
        <span><img src="./assets/ILD_admin_ic_xtgl.png" alt=""></span>
        <em>系统管理</em>
      </a>
      <a href="">
        <span></span>
        <em>项目动态</em>
      </a>
      <a href="">
        <span></span>
        <em>通知公告编辑</em>
      </a>
      <a href="">
        <span></span>
        <em>新闻咨询编辑</em>
      </a>
      <a href="">
        <span></span>
        <em>注册数据展示</em>
      </a>
      <a href="" class="active">
        <span><img src="./assets/ILD_admin_ic_glygl.png" alt=""></span>
        <em>管理员管理</em>
      </a>
      <a href="">
        <span><img src="./assets/ILD_admin_ic_grzx.png" alt=""></span>
        <em>个人中心</em>
      </a>
    </div>
  </div>
  <div class="right">
    <div class="right_nav">      
      <div>
        <a href="">首页</a>
        <span>></span>
        <a href="">系统管理</a>
        <span>></span>
        <a href="">权限管理</a>
      </div>
      <div class="head_img">
        <img src="./assets/ILD_admin_ic_name.png" alt="">
        <span>admin</span>
      </div>
    </div>
    <div class="right_con">
      <div class="create_but">
        <button>创建</button>
      </div>
      <div class="list">
        <table>
          <tr class="title">
            <td>权限名称</td>
            <td>权限中文名称</td>
            <td>创建时间</td>
            <td>更新时间</td>
            <td>操作</td>
          </tr>
          <tr>
            <td>telescope</td>
            <td>telescope</td>
            <td>2023-07-03 10:23:09</td>
            <td>2023-07-03 10:23:09</td>
            <td colspan="2">
              <a href="" class="edit">编辑</a>
              <a href="" class="del">删除</a>
            </td>
          </tr>
          <tr>
            <td>telescope</td>
            <td>telescope</td>
            <td>2023-07-03 10:23:09</td>
            <td>2023-07-03 10:23:09</td>
            <td colspan="2">
              <a href="" class="edit">编辑</a>
              <a href="" class="del">删除</a>
            </td>
          </tr>
          <tr>
            <td>telescope</td>
            <td>telescope</td>
            <td>2023-07-03 10:23:09</td>
            <td>2023-07-03 10:23:09</td>
            <td colspan="2">
              <a href="" class="edit">编辑</a>
              <a href="" class="del">删除</a>
            </td>
          </tr>
          <tr>
            <td>telescope</td>
            <td>telescope</td>
            <td>2023-07-03 10:23:09</td>
            <td>2023-07-03 10:23:09</td>
            <td colspan="2">
              <a href="" class="edit">编辑</a>
              <a href="" class="del">删除</a>
            </td>
          </tr>
          <tr>
            <td>telescope</td>
            <td>telescope</td>
            <td>2023-07-03 10:23:09</td>
            <td>2023-07-03 10:23:09</td>
            <td colspan="2">
              <a href="" class="edit">编辑</a>
              <a href="" class="del">删除</a>
            </td>
          </tr>
          <tr>
            <td>telescope1</td>
            <td>telescope2</td>
            <td>2023-07-03 10:23:09</td>
            <td>2023-07-03 10:23:09</td>
            <td colspan="2">
              <a href="" class="edit">编辑</a>
              <a href="" class="del">删除</a>
            </td>
          </tr>
        </table>
        <div class="paging">
          <span>1</span>
          <span class="active">2</span>
          <span>3</span>
          <span>4</span>
          <span>5</span>
          <span>6</span>
          <span>7</span>
          <span>8</span>
          <span>9</span>
          <span>10</span>
          <em>上一页</em>
          <em>下一页</em>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom">    
    <p>技术支持: 北京风云朗健科技有限公司</p>
    <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
  </div>
</div>
<!-- 后台admin end-->


<!-- 项目动态 -->
<div class="admin_con" style="display: none;">
  <div class="left">
    <div class="admin_logo">
      <img src="./assets/ILD_admin_logo.png" alt="">
    </div>
    <div class="admin_nav">
      <a href="">
        <span><img src="./assets/ILD_admin_ic_xtgl.png" alt=""></span>
        <em>系统管理</em>
      </a>
      <a href="" class="active">
        <span></span>
        <em>项目动态</em>
      </a>
      <a href="">
        <span></span>
        <em>通知公告编辑</em>
      </a>
      <a href="">
        <span></span>
        <em>新闻资讯编辑</em>
      </a>
      <a href="">
        <span></span>
        <em>注册数据展示</em>
      </a>
      <a href="">
        <span><img src="./assets/ILD_admin_ic_glygl.png" alt=""></span>
        <em>管理员管理</em>
      </a>
      <a href="">
        <span><img src="./assets/ILD_admin_ic_grzx.png" alt=""></span>
        <em>个人中心</em>
      </a>
    </div>
  </div>
  <div class="right">
    <div class="right_nav">      
      <div>
        <a href="">首页</a>
        <span>></span>
        <a href="">系统管理</a>
        <span>></span>
        <a href="">权限管理</a>
      </div>
      <div class="head_img">
        <img src="./assets/ILD_admin_ic_name.png" alt="">
        <span>admin</span>
      </div>
    </div>
    <div class="goback">
      <img src="./assets/ILD_admin_ic_fh.png" alt="">
    </div>
    <div class="dynamic">
      <div class="title">项目动态</div>
      <div class="img_con">
        <div class="img_list">
          <div>
            <span>第一张</span>
            <p>
              <input type="file">
              <img class="del" src="./assets/ILD_admin_ic_del.png" alt="">
              <img src="./assets/ILD_xmjj_jsbzjs_1.png" alt="">
            </p>
            <em>
              <button>发布</button>
              <button class="del">取消发布</button>
            </em>
          </div>
          <div>
            <span>第二张</span>
            <p>
              <input type="file">
              <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="">
            </p>
            <em>
              <button>发布</button>
              <button class="del">取消发布</button>
            </em>
          </div>
          <div>
            <span>第三张</span>
            <p>
              <input type="file">
              <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="">
            </p>
            <em>
              <button>发布</button>
              <button class="del">取消发布</button>
            </em>
          </div>
          <div>
            <span>第四张</span>
            <p>
              <input type="file">
              <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="">
            </p>
            <em>
              <button>发布</button>
              <button class="del">取消发布</button>
            </em>
          </div>
          <div>
            <span>第五张</span>
            <p>
              <input type="file">
              <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="">
            </p>
            <em>
              <button>发布</button>
              <button class="del">取消发布</button>
            </em>
          </div>
        </div>
        <button>上传</button>
      </div>
    </div>
  </div>
  <div class="bottom">    
    <p>技术支持: 北京风云朗健科技有限公司</p>
    <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
  </div>
</div>
<!-- 项目动态 end-->


<!-- 通知公告编辑 -->
<div class="admin_con" style="display: none;">
  <div class="left">
    <div class="admin_logo">
      <img src="./assets/ILD_admin_logo.png" alt="">
    </div>
    <div class="admin_nav">
      <a href="">
        <span><img src="./assets/ILD_admin_ic_xtgl.png" alt=""></span>
        <em>系统管理</em>
      </a>
      <a href="">
        <span></span>
        <em>项目动态</em>
      </a>
      <a href="" class="active">
        <span></span>
        <em>通知公告编辑</em>
      </a>
      <a href="">
        <span></span>
        <em>新闻资讯编辑</em>
      </a>
      <a href="">
        <span></span>
        <em>注册数据展示</em>
      </a>
      <a href="">
        <span><img src="./assets/ILD_admin_ic_glygl.png" alt=""></span>
        <em>管理员管理</em>
      </a>
      <a href="">
        <span><img src="./assets/ILD_admin_ic_grzx.png" alt=""></span>
        <em>个人中心</em>
      </a>
    </div>
  </div>
  <div class="right">
    <div class="right_nav">      
      <div>
        <a href="">首页</a>
        <span>></span>
        <a href="">系统管理</a>
        <span>></span>
        <a href="">权限管理</a>
      </div>
      <div class="head_img">
        <img src="./assets/ILD_admin_ic_name.png" alt="">
        <span>admin</span>
      </div>
    </div>
    <div class="goback">
      <img src="./assets/ILD_admin_ic_fh.png" alt="">
    </div>
    <div class="dynamic">
      <div class="title">通知公告编辑</div>
      <div class="img_con">
        <div class="edit_con">
          <div class="data">
            <select name="" id="">
              <option value="0">年</option>
              <option value="1">2023</option>
              <option value="2">2022</option>
            </select>
            <select name="" id="">
              <option value="0">月</option>
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
            <select name="" id="">
              <option value="0">日</option>
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </div>
          <div class="edit">
            嵌入编辑器
          </div>
        </div>
        <button>保存</button>
      </div>
    </div>
  </div>
  <div class="bottom">    
    <p>技术支持: 北京风云朗健科技有限公司</p>
    <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
  </div>
</div>
<!-- 通知公告编辑 end-->


<!-- 新闻资讯编辑 -->
<div class="admin_con" style="display: none;">
  <div class="left">
    <div class="admin_logo">
      <img src="./assets/ILD_admin_logo.png" alt="">
    </div>
    <div class="admin_nav">
      <a href="">
        <span><img src="./assets/ILD_admin_ic_xtgl.png" alt=""></span>
        <em>系统管理</em>
      </a>
      <a href="">
        <span></span>
        <em>项目动态</em>
      </a>
      <a href="">
        <span></span>
        <em>通知公告编辑</em>
      </a>
      <a href="" class="active">
        <span></span>
        <em>新闻资讯编辑</em>
      </a>
      <a href="">
        <span></span>
        <em>注册数据展示</em>
      </a>
      <a href="">
        <span><img src="./assets/ILD_admin_ic_glygl.png" alt=""></span>
        <em>管理员管理</em>
      </a>
      <a href="">
        <span><img src="./assets/ILD_admin_ic_grzx.png" alt=""></span>
        <em>个人中心</em>
      </a>
    </div>
  </div>
  <div class="right">
    <div class="right_nav">      
      <div>
        <a href="">首页</a>
        <span>></span>
        <a href="">系统管理</a>
        <span>></span>
        <a href="">权限管理</a>
      </div>
      <div class="head_img">
        <img src="./assets/ILD_admin_ic_name.png" alt="">
        <span>admin</span>
      </div>
    </div>
    <div class="goback">
      <img src="./assets/ILD_admin_ic_fh.png" alt="">
    </div>
    <div class="dynamic">
      <div class="title">新闻资讯编辑</div>
      <div class="img_con">
        <div class="edit_con">
          <div class="edit">
            嵌入编辑器
          </div>
          <div class="edit">
            嵌入编辑器
          </div>
        </div>
        <div class="img_list edit_img">
          <div>
            <span>图片上传</span>
            <p>
              <input type="file">
              <img class="del" src="./assets/ILD_admin_ic_del.png" alt="">
              <img src="./assets/ILD_xmjj_jsbzjs_1.png" alt="">
            </p>
          </div>
        </div>
        <button>保存</button>
      </div>
    </div>
  </div>
  <div class="bottom">    
    <p>技术支持: 北京风云朗健科技有限公司</p>
    <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
  </div>
</div>
<!-- 新闻资讯编辑 end-->


<!-- 注册数据展示 -->
<div class="admin_con" style="display: none;">
  <div class="left">
    <div class="admin_logo">
      <img src="./assets/ILD_admin_logo.png" alt="">
    </div>
    <div class="admin_nav">
      <a href="">
        <span><img src="./assets/ILD_admin_ic_xtgl.png" alt=""></span>
        <em>系统管理</em>
      </a>
      <a href="">
        <span></span>
        <em>项目动态</em>
      </a>
      <a href="">
        <span></span>
        <em>通知公告编辑</em>
      </a>
      <a href="">
        <span></span>
        <em>注册人数</em>
      </a>
      <a href="" class="active">
        <span></span>
        <em>注册数据展示</em>
      </a>
      <a href="">
        <span><img src="./assets/ILD_admin_ic_glygl.png" alt=""></span>
        <em>管理员管理</em>
      </a>
      <a href="">
        <span><img src="./assets/ILD_admin_ic_grzx.png" alt=""></span>
        <em>个人中心</em>
      </a>
    </div>
  </div>
  <div class="right">
    <div class="right_nav">      
      <div>
        <a href="">首页</a>
        <span>></span>
        <a href="">系统管理</a>
        <span>></span>
        <a href="">权限管理</a>
      </div>
      <div class="head_img">
        <img src="./assets/ILD_admin_ic_name.png" alt="">
        <span>admin</span>
      </div>
    </div>
    <div class="goback">
      <img src="./assets/ILD_admin_ic_fh.png" alt="">
    </div>
    <div class="dynamic">
      <div class="title">注册人数</div>
      <div class="img_con">
        <div class="data_con">
          <img src="./assets/qushi.png" alt="">
        </div>
      </div>
    </div>
  </div>
  <div class="bottom">    
    <p>技术支持: 北京风云朗健科技有限公司</p>
    <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
  </div>
</div>
<!-- 注册数据展示 end-->


<!-- 移动端 -->

<div class="h5_block">
  
  <!-- 首页 -->
  <div class="h5_index">
    <div class="banner">
      <img src="./assets/ildapp_home_banner.png" alt="">
    </div>
    <div class="nav">
      <a>
        <img src="./assets/ildapp_home_ic_xwzx.png" alt="">
        <span>新闻资讯</span>
      </a>
      <a>
        <img src="./assets/ildapp_home_ic_xmjj.png" alt="">
        <span>项目介绍</span>
      </a>
      <a>
        <img src="./assets/ildapp_home_ic_zlzxjslc.png" alt="">
        <span>诊疗中心<br>建设流程</span>
      </a>
      <a>
        <img src="./assets/ildapp_home_ic_zlzxps.png" alt="">
        <span>诊疗中心评审</span>
      </a>
      <a>
        <img src="./assets/ildapp_home_ic_lxwm.png" alt="">
        <span>联系我们</span>
      </a>
      <a>
        <img src="./assets/ildapp_home_ic_tz.png" alt="">
        <span>通知公告</span>
      </a>
    </div>
  </div>

  <!-- 技术支持 -->
  <div class="ild_con">
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>

  <!-- 新闻资讯 -->
  <div class="ild_con">
    <div class="news_notice_h5">
      <div class="news_h5">
        <dl>
          <dt><img src="./assets/img.png" alt=""></dt>
          <dd>
            <p>[专题讲座]XXXXX</p>
            <span>我们邀请到临床、影像、病理、细胞室、肺功能室等......</span>
            <em>2023-06-21</em>
          </dd>
        </dl>
        <dl>
          <dt><img src="./assets/img.png" alt=""></dt>
          <dd>
            <p>[专题讲座]XXXXX</p>
            <span>我们邀请到临床、影像、病理、细胞室、肺功能室等......</span>
            <em>2023-06-21</em>
          </dd>
        </dl>
        <dl>
          <dt><img src="./assets/img.png" alt=""></dt>
          <dd>
            <p>[专题讲座]XXXXX</p>
            <span>我们邀请到临床、影像、病理、细胞室、肺功能室等......</span>
            <em>2023-06-21</em>
          </dd>
        </dl>
        <dl>
          <dt><img src="./assets/img.png" alt=""></dt>
          <dd>
            <p>[专题讲座]XXXXX</p>
            <span>我们邀请到临床、影像、病理、细胞室、肺功能室等......</span>
            <em>2023-06-21</em>
          </dd>
        </dl>
      </div>
    </div>
  </div>

  <!-- 技术支持 -->
  <div class="ild_con">
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
  </div>

  <!-- 登录 -->
  <div class="login_h5">
    <div class="login">      
      <img src="./assets/ildapp_login_logo.png" alt="">
    </div>
    <div class="login_input">
      <div>
        <input type="text" placeholder="用户名/手机号">
      </div>
      <div>
        <input type="password" placeholder="请输入验证码">
        <a href="">获取验证码</a>
      </div>
    </div>
    <div class="register">
      <a href="">注册</a>
      <a href="">找回密码</a>
      <a href="" class="color3aa8af">工作人员登录</a>
    </div>
    <button>登录</button>
    <div class="copyright">
      <p>技术支持: 北京风云朗健科技有限公司</p>
      <p>京ICP备14058841号</p>
      <p>电话:010-67309068</p>
    </div>
  </div>

  <!-- 注册 -->
  <div class="d_register">
    <div>
      <img src="./assets/ildapp_zc_ic_name.png" alt="">
      <span>姓名</span>
      <input type="text" placeholder="必填">
    </div>
    <div>
      <img src="./assets/ildapp_zc_ic_dq.png" alt="">
      <span>地区</span>
      <select name="" id="">
        <option value="1">1</option>
        <option value="2">3</option>
      </select>
    </div>
    <div class="division"></div>
    <div>
      <img src="./assets/ildapp_zc_ic_sj.png" alt="">
      <span>手机号</span>
      <input type="text" placeholder="必填">
    </div>
    <div>
      <img src="./assets/ildapp_zc_ic_yzm.png" alt="">
      <span>验证码</span>
      <input type="text" placeholder="必填" class="width35">
      <em class="colorf6b169">获取验证码</em>
    </div>
    <div class="division"></div>
    <div>
      <img src="./assets/ildapp_zc_ic_yy.png" alt="">
      <span>医院</span>
      <select name="" id="">
        <option value="1">1</option>
        <option value="2">3</option>
      </select>
    </div>
    <div>
      <img src="./assets/ildapp_zc_ic_ysz.png" alt="">
      <span>医师证编号<br>或身份证号</span>
      <input type="text" placeholder="必填" class="width50">
    </div>
    <div class="division"></div>
    <button>保存</button>
  </div>

  <!-- 找回密码 -->
  <div class="d_register">
    <div>
      <img src="./assets/ildapp_zhmm_ic_sj.png" alt="">
      <input type="text" placeholder="请输入您的手机号">
    </div>
    <div>
      <img src="./assets/ildapp_zhmm_ic_yzm.png" alt="">
      <input type="text" placeholder="请输入验证码" class="width35">
      <em class="colorf6b169">获取验证码</em>
    </div>
    <div class="division"></div>
    <div>
      <img src="./assets/ildapp_zhmm_ic_mm.png" alt="">
      <input type="password" placeholder="请输入新密码" class="width50">
    </div>
    <div>
      <img src="./assets/ildapp_zhmm_ic_mm.png" alt="">
      <input type="password" placeholder="请再一次输入新密码" class="width50">
    </div>
    <div class="division"></div>
    <button>完成</button>
  </div>

</div>

<!-- 移动端 end -->
